<template>
  <div class="page">
    <!-- 关于宝成哦 -->
    <div class="nav_top"></div>
    <navigation-bar2 />
    <div class="swiperModel">
      <div v-for="(item, index) in lunboImgs" :key="index"><img :src="imgUrl + item.img" alt="" /></div>
    </div>

    <div class="options">
      <div @click="tabOtpions('1')">企业简介</div>
      <div @click="tabOtpions('2')">资质荣誉</div>
      <div @click="tabOtpions('3')">核心团队</div>
      <div @click="tabOtpions('4')">联系我们</div>
    </div>
    <div class="optionsItem">
      <!-- 企业简介 -->
      <div v-show="viewShow1" class="introduce" v-for="(item, index) in enterpriseProfileImgs" :key="index + '1'">
        <div><img :src="imgUrl + item.img" alt="" /></div>
      </div>
      <!-- 荣誉资质start -->
      <div v-show="viewShow2" class="introduce" v-for="(item, index) in qualificationHonorImgs" :key="index + '2'">
        <div><img :src="imgUrl + item.img" alt="" /></div>
      </div>
      <!-- 荣誉团队end -->
      <!-- 核心团队start -->
      <div v-show="viewShow3" class="introduce" v-for="(item, index) in corrTeamImgs" :key="index + '3'">
        <div><img :src="imgUrl + item.img" alt="" /></div>
      </div>
      <!-- 核心团队end -->
      <!-- 联系我们start -->
      <div v-show="viewShow4" class="introduce">
        <div class="formStyle">
          <el-form :model="form" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item prop="name">
              <el-input placeholder="姓名" prefix-icon="el-icon-user" v-model.trim="form.name" />
            </el-form-item>
            <el-form-item prop="email">
              <el-input placeholder="邮箱" prefix-icon="el-icon-user" v-model.trim="form.email" />
            </el-form-item>
            <el-form-item prop="cline">
              <el-input placeholder="公司名称" prefix-icon="el-icon-user" v-model.trim="form.cline" />
            </el-form-item>
            <el-form-item prop="tel">
              <el-input placeholder="联系电话" prefix-icon="el-icon-user" v-model.trim="form.tel" />
            </el-form-item>
            <el-form-item prop="content" style="width:100% !important">
              <el-input type="textarea" :rows="2" placeholder="留言内容" v-model="form.content" />
            </el-form-item>
            <div class="verification">
              <el-form-item style="width: 400px;margin-right:10px;" v-if="!isYzm" prop="yzm">
                <el-input placeholder="请输入手机号验证码" prefix-icon="el-icon-user" v-model.trim="form.telYzm" />
              </el-form-item>
              <el-form-item style="width: 350px;margin-right:10px;" prop="yzm" v-if="isYzm">
                <el-input placeholder="图形验证码" prefix-icon="el-icon-user" v-model="form.yzm" />
              </el-form-item>
              <el-form-item v-if="isYzm">
                <s-identify :identifyCode="identifyCode"></s-identify>
              </el-form-item>
              <el-form-item v-if="isYzm">
                <el-button @click="refreshCode">看不清？换一张</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :disabled="yzmDisabled" plain @click="getYZM">{{ text }}</el-button>
              </el-form-item>
            </div>
          </el-form>
          <div class="btn">
            <el-button type="primary" @click="submit">提交</el-button>
          </div>
        </div>
      </div>
      <!-- 联系我们end -->
    </div>
    <bottom-area />
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      viewShow1: true,
      viewShow2: false,
      viewShow3: false,
      viewShow4: false,
      form: {
        name: "",
        email: "",
        cline: "",
        tel: "",
        content: "",
        yzm: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        cline: [{ required: true, message: "请输入贵公司名称", trigger: "blur" }],
        tel: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { min: 11, max: 11, message: "手机号格式不正确", trigger: "blur" },
        ],
        content: [{ required: true, message: "请输入您的宝贵意见", trigger: "blur" }],
        yzm: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      identifyCodes: "1234567890",
      identifyCode: "",
      time: 60,
      text: "获取验证码",
      yzmDisabled: false,
      isYzm: true,
      lunboImgs: [],
      enterpriseProfileImgs: [],
      qualificationHonorImgs: [],
      corrTeamImgs: [],
      imgUrl: this.$store.state.imgUrl,
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  components: {
    NavigationBar2: () => import("../views/nav/NavigationBar2"),
    BottomArea: () => import("../views/footer/BottomArea"),
    sIdentify: () => import("../components/identify/identify"),
  },
  methods: {
    async getData() {
      const { data: res } = await this.$http.get("/aboutBaocheng/list");
      if (res.code == 200) {
        this.lunboImgs = res.result.lunboImgs;
        this.enterpriseProfileImgs = res.result.enterpriseProfileImgs;
        this.qualificationHonorImgs = res.result.qualificationHonorImgs;
        this.corrTeamImgs = res.result.corrTeamImgs;
      }
    },
    tabOtpions(type) {
      switch (type) {
        case "1":
          this.viewShow1 = true;
          this.viewShow2 = false;
          this.viewShow3 = false;
          this.viewShow4 = false;
          break;
        case "2":
          this.viewShow1 = false;
          this.viewShow2 = true;
          this.viewShow3 = false;
          this.viewShow4 = false;
          break;
        case "3":
          this.viewShow1 = false;
          this.viewShow2 = false;
          this.viewShow3 = true;
          this.viewShow4 = false;
          break;
        case "4":
          this.viewShow1 = false;
          this.viewShow2 = false;
          this.viewShow3 = false;
          this.viewShow4 = true;
          break;
        default:
          break;
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    sendYzm() {},
    async getYZM() {
      if (this.form.tel == "") {
        this.$message.warning("请先填写手机号");
        return;
      } else if (this.form.yzm == "") {
        this.$message.warning("请先输入图形验证码");
        return;
      } else if (this.form.yzm !== this.identifyCode) {
        this.$message.warning("图形验证码输入有误");
        return;
      } else {
        this.yzmDisabled = true;
        this.isYzm = false;
        this.timer = setInterval(() => {
          this.time--;
          this.text = this.time + "后重新获取";
          if (this.time === 0) {
            clearInterval(this.timer);
            this.yzmDisabled = false;
            this.isYzm = true;
            this.time = 60;
            this.text = "获取验证码";
          }
        }, 1000);
      }
      const { data: res } = await this.$http.get("/aboutBaocheng/verificate", {
        params: {
          tel: this.form.tel,
        },
      });
      if (res.code == 200) {
        this.$message.success("验证码已发生至您的手机，请注意查收！");
      } else {
        this.$message({
          message: res.msg,
          message: "error",
        });
      }
    },
    submit() {
      if (this.identifyCode !== this.form.yzm) {
        this.$message.warning("验证码输入错误");
        return;
      }
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.yzmDisabled = true;
          const { data: res } = await this.$http.post("/aboutBaocheng/submitMsg", {
            comment: this.form.cline,
            name: this.form.name,
            phone: this.form.tel,
            eMail: this.form.email,
            company: this.form.content,
            captcha: this.form.telYzm,
          });
          console.log(res);
          if (res.code == 200) {
            console.log(res);
            this.$message({
              message: "提交成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          this.form = Object.assign({}, "");
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.nav_top {
    width: 100%;
    height: 15px;
    background-color: #19344a;
    color: #ffffff;
  }
.swiperModel {
  width: 100%;
  height: 680px;
}
.options {
  width: 100%;
  height: 150px;
  line-height: 150px;
  display: flex;
  justify-content: space-between;
  background-color: #f0f1f3;
  padding: 0 400px 0 400px;
  box-sizing: border-box;
  div {
    font-size: 25px;
    letter-spacing: 5px;
    cursor: pointer;
  }
}
.formStyle {
  width: 600px;
  height: 600px;
  margin: 30px auto;
  .el-form {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-form-item {
      // display: inline-block;
      width: 45% !important;
    }
  }
  .verification {
    width: 100%;
    display: flex;
  }
  .btn {
    width: 100%;
    text-align: center;
    .el-button {
      width: 200px;
    }
  }
}
</style>
